// extracted by mini-css-extract-plugin
export var IconContainer = "index-module--IconContainer--RAMnZ";
export var RightIcon = "index-module--RightIcon--GPX1X";
export var bgBlack = "index-module--bgBlack--7EPFX";
export var heroInfoWrapper = "index-module--heroInfoWrapper--BCbEt";